fx.ns("requests", class UploadRequest extends fx.Service
{
    constructor(data)
    {
        super();

        this.model = data;

        this._uploadFileProgressHandler = this._uploadFileProgress.bind(this);
        this._uploadFileSuccessHandler = this._uploadFileSuccess.bind(this);
        this._uploadFileErrorHandler = this._uploadFileError.bind(this);
        this._uploadFileAddedHandler = this._uploadFileAdded.bind(this);

        this._startDate;
        this._speed;
    }

    get currentFile()
    {
        return this._currentFile;
    }

    get speed()
    {
        return this._speed;
    }

    uploadFile(url, file, slow)
    {
        this._currentFile = file;
        this._currentFile._upload.uploading = true;
        this._currentFile._upload.uploaded = false;
        this._currentFile._upload.tries++;
        this._currentFile._upload.slow = slow;
            
        this._startUpload(url);

        this.trigger("photo-upload-started", this);
    }

    _startUpload(url)
    {
        this._resumable = new Resumable({
                                            chunkSize: (this._currentFile._upload.slow ? 0.25 : 0.5) * 1024 * 1024, // 0.5 / 1miB,
                                            forceChunkSize : this._currentFile._upload.slow ,
                                            testChunks: false,
                                            simultaneousUploads: 2,
                                            maxChunkRetries: 10,        // 10 chunk retries (10*10s = 100s of chunk retries)
                                            chunkRetryInterval: 1000,   // 1 chunk retry each 10s
                                            xhrTimeout: 70000,         // request timeout after 1min10
                                            target: url
                                        });
                                        
        this._resumable.on('fileSuccess', this._uploadFileSuccessHandler);
        this._resumable.on('fileAdded', this._uploadFileAddedHandler);
        this._resumable.on('fileError', this._uploadFileErrorHandler);
        this._resumable.on('fileProgress', this._uploadFileProgressHandler);

        this._resumable.addFile(this._currentFile.file);
    }

    _uploadFileProgress(file) 
    {
        if (!this._currentFile) return;

        if (this._currentFile.file && this._currentFile.file.size )
            this._currentFile._upload.loaded = (this._currentFile.file.size)*(file.progress());

        if (this._currentFile._upload.loaded)
            this._speed = this._currentFile._upload.loaded / ( Math.max(new Date() - this._startDate, 1) );

        this._currentFile.event("upload-file-progress");
        this.trigger("photo-upload-progress", { request : this, speed : this.speed, progress : this._currentFile._upload.loaded });
    }

    _uploadFileError(file, message) {
        this._chunkerror();
    }

    _uploadFileAdded(file, event){
        this._resumable.upload();
        this._startDate = new Date();
    }

    _uploadFileSuccess(file, res){
        let response = JSON.parse(res);

        if (response.success && response.completionUrl)
        {
            this.post(response.completionUrl, this._currentFile.uploadParams, this._uploadCallback);
        }
        else
            this._requesterror();
    }

    _uploadCallback(result)
    {
        if (!result.error && result.id)
        {
            this._currentFile._upload.loaded = this._currentFile._upload.size || 1;
            this._currentFile._upload.uploading = false;
            this._currentFile._upload.uploaded = true;

            if (this._currentFile._upload.toResend)
            {
                this._currentFile.cancel(result.id);
                this._currentFile._upload.toResend = false;
            }
            else
            {
                Utils.temporaryId(this._currentFile.id, result.id);
                
                this._currentFile.prop("oldid", this._currentFile.id);

                this._currentFile.clean();

                this._currentFile.update({
                                    id : result.id,
                                    hash : this._currentFile.id,
                                    width : result.width,
                                    height : result.height,
                                    number : this._currentFile.number, // so we force update this value in case it was updated while photo was uploading
                                    deleted : this._currentFile.deleted, // -- same
                                    faces : this._currentFile.faces, // -- same
                                    average_color : this._currentFile.average_color,
                                    thumb : Utils._fixURL(result.thumb),
                                    url : Utils._fixURL(result.url),
                                    light_url : Utils._fixURL(result.url)
                                });

                this._currentFile.event("media-file-uploaded");
            }
            this._stopUpload();
            this.trigger("photo-upload-finished", this);
        }
        else
        {
            this._requesterror();
        }    
    }

    _stopUpload()
    {
        this._uploadFileProgressHandler = null;
        this._uploadFileSuccessHandler = null;
        this._uploadFileErrorHandler = null;
        this._uploadFileAddedHandler = null;

        if (this._resumable)
        {
            this._resumable.cancel();
            this._resumable = null;
        }
    }

    _resetUpload(){
        if (this._currentFile)
        {
            this._currentFile._upload.uploading = false;
            this._currentFile._upload.uploaded = false;
            this._currentFile._upload.loaded = 0;
        }
        this._stopUpload();
    }

    _chunkerror(){
        this._resetUpload();
        this.trigger("chunk-upload-error", this);
    }

    _requesterror(){
        this._resetUpload();
        this.trigger("photo-upload-error", this);
    }

});
    